import React, { useState, useEffect } from "react";
import { Modal, Grid, Card, Feed, Label, Table } from "semantic-ui-react";
import SecondaryBlueButton from "components/Buttons/SecondaryBlueButton";
import { getFormattedTimeFromSeconds } from "utils/dateUtils";
import * as _ from "lodash";
import moment from "moment";
import ReminderRow from "./ReminderRow";

const PreregisterRecallsModal = ({ open, close, recalls, saveReminder }) => {
	const [list2d, setList2d] = useState([]);
	const [list10d, setList10d] = useState([]);
	const [setDates, setSetDates] = useState([]);

	useEffect(() => {
		setSetDates([
			...new Set(
				[...new Set(recalls?.map((recall) => recall.reminder_date_2d)), ...new Set(recalls?.map((recall) => recall.reminder_date_10d))].filter(
					(d) => moment(d) >= moment().startOf("day")
				)
			),
		]);
		setList2d([...recalls].sort((a, b) => moment(a.reminder_date_2d) - moment(b.reminder_date_2d)));
		setList10d([...recalls].sort((a, b) => moment(a.reminder_date_10d) - moment(b.reminder_date_10d)));
	}, [recalls]);
	return (
		<Modal closeIcon open={open} closeOnEscape closeOnDimmerClick onClose={close} size="large">
			<Modal.Header>Rappels prévus</Modal.Header>
			<Modal.Content>
				{setDates &&
					setDates.length > 0 &&
					setDates
						.sort((a, b) => moment(a) - moment(b))
						.map((date) => (
							<Grid>
								<Grid.Row>{moment(date).format("DD/MM/YYYY")} </Grid.Row>
								<Grid.Row columns={3}>
									{list10d
										.filter((l) => l.reminder_date_10d === date)
										.map((l) => (
											<ReminderRow reminder={l} days={10} saveReminder={saveReminder} />
										))}
								</Grid.Row>
								<Grid.Row columns={3}>
									{list2d
										.filter((l) => l.reminder_date_2d === date && !list10d.some((l10d) => l10d.id === l.id))
										.map((l) => (
											<ReminderRow reminder={l} days={2} saveReminder={saveReminder} />
										))}
								</Grid.Row>
							</Grid>
						))}
			</Modal.Content>
			<Modal.Actions>
				<SecondaryBlueButton negative onClick={() => close()}>
					Fermer
				</SecondaryBlueButton>
			</Modal.Actions>
		</Modal>
	);
};

export default PreregisterRecallsModal;
